"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { usePlasmicCanvasContext } from "@plasmicapp/host";
import { useEffect, useState } from "react";
export const LGTimeFromNowProps = {
    offsetMinutes: {
        type: "number",
        defaultValue: 15,
        displayName: "Offset (minutes)",
        description: "Minutes added to the visitor's current time.",
    },
    template: {
        type: "string",
        defaultValue: "{time}",
        displayName: "Template",
        description: 'Text to render; "{time}" is replaced with the formatted HH:MM value.',
    },
    placeholder: {
        type: "string",
        defaultValue: "--:--",
        displayName: "Placeholder",
        description: "Rendered on the server and until the component mounts. Keep it the same width as the " +
            "real value to avoid layout shift. Ignored in the Plasmic Studio canvas, which always " +
            "previews a live time.",
    },
};
const formatTime = (offsetMinutes) => {
    const at = new Date();
    at.setMinutes(at.getMinutes() + offsetMinutes);
    return `${String(at.getHours()).padStart(2, "0")}:${String(at.getMinutes()).padStart(2, "0")}`;
};
export function LGTimeFromNow({ offsetMinutes = 15, template = "{time}", placeholder = "--:--", className, }) {
    const inEditor = usePlasmicCanvasContext();
    const [time, setTime] = useState(null);
    useEffect(() => {
        setTime(formatTime(offsetMinutes));
    }, [offsetMinutes]);
    const value = time ?? (inEditor ? formatTime(offsetMinutes) : placeholder);
    return _jsx("span", { className: className, children: template.replace("{time}", value) });
}
